import http from 'conversations-http/clients/http';
/**
 * This function will take a ticket ID and mark it as read.
 */
export const markTicketAsReadByAgent = (id, inboxId) => http.put(`/conversations-custom-views/v1/agent-read/read/ticket/${id}`, {
  data: {
    inboxId
  }
});